/**
 * Shared types for Microservice Generator
 * This file can be imported by both frontend and backend
 */

export interface FormParams {
    TECH_STACK?: string;
    SERVICE_NAME?: string;
    SERVICE_REPO_NAME?: string;
    PRODUCT_GROUP?: string[];
    ORG?: string;
    MAINTAINER_TEAMS?: string[];
    DESCRIPTION?: string;
    DOMAIN?: string;
    FUNCTIONAL_AREA?: string;
    // Infra Dependencies
    DB_CHOICE?: string;
    KAFKA_ENABLED?: boolean;
    REDIS_ENABLED?: boolean;
    // Advanced Options (optional)
    TEMPLATE_REPO_BRANCH?: string;
    DEPLOY_REPO_BRANCH?: string;
    GENERATOR_BRANCH_NAME?: string;
}

export interface MicroserviceGenerationRequest {
    formData: FormParams;
    userId?: string;
    timestamp?: string;
}

export interface MicroserviceGenerationResponse {
    success: boolean;
    message: string;
    jobId?: string;
    repositoryUrl?: string;
    error?: string;
}

// Validation helper types
export interface ValidationResult {
    isValid: boolean;
    errors: string[];
}

export interface FormFieldValidation {
    [fieldName: string]: string; // field name -> error message
}

// Repository existence check response
export interface RepositoryExistsResponse {
    organization: string;
    repository: string;
    exists: boolean;
    message: string;
}

// Repository naming utilities
export const getRepositoryPrefix = (techStack: string): string => {
  switch (techStack?.toLowerCase()) {
    case 'reactjs':
      return 'fe-';
    case 'ruby-fullstack':
      return 'fs-';

    case 'java':
    case 'scala':
    case 'ruby':
    case 'python-fastapi':
      return 'service-';

    default:
      return '';
  }
};

export const getPrefixedRepositoryName = (serviceName: string, techStack: string): string => {
    const prefix = getRepositoryPrefix(techStack);
    return `${prefix}${serviceName}`;
};
